import { createFileRoute } from '@tanstack/react-router';

import { DestinationContainer } from '@/features/destinations/containers/[destinationId]';

export const Route = createFileRoute('/_layout/destinations/$destinationId')({
  component: DestinationContainer,
});
